export default __webpack_public_path__ + "static/media/avatarImage.2dceb20a.png";